import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useEffect, useRef } from 'react';

export const usePreviousInBackButton = () => {
  const { processHandlers, context } = useProcess();

  const handlerRef = useRef();
  handlerRef.current = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);

    const handler = () => {
      history.pushState(null, '', window.location.href);
      handlerRef.current();
    };

    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);
};
